<template>
    <div class="searchbox-block">

        <div class="searchbox-area">
            <div v-if="input_searchValue" class="searchbox-info">
                {{ $t('menu.search_count') }}：{{ result_count }}
            </div>
            <div class="searchbox-icon">
                <i class="fa fa-search" v-b-tooltip.hover :title="search_tooltip"></i>
            </div>
            <div class="searchbox-bar">
                <b-form-input type="text" class="searchbox-input"
                          v-model.trim="input_searchValue"
                          :placeholder="$t('menu.search')" />
            </div>
            <div class="searcjbox-close" @click="clearSearchValue">x</div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        // 要搜尋的原始資料串
        list_data: {
            type: Array,
            required: true,
        },
        // 除了 searchValue 還要搜尋原始資料串的哪個 key 的值
        search_key: {
            type: Array,
        },
        // 要顯示給使用者的操作提示
        search_tooltip: {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            input_searchValue: '',
            result_count: 0,
        }
    },
    mounted ()
    {

        // 初始化要清掉搜尋輸入 & 回傳最原始的資料串
        this.clearSearchValue();
        this.emitValue( this.list_data );
        
    },
    computed: {

    },
    watch: {

        list_data (val, oldVal)
        {
            this.clearSearchValue();
            this.emitValue( this.list_data );
        },

        input_searchValue (val, oldVal)
        {
            if (this.input_searchValue == '')
            {
                this.emitValue( this.list_data );
            }
            else
            {
                this.emitValue( this.search() );
            }
        },

    },
    methods: {

        emitValue (result)
        {
            this.result_count = result.length;
            this.$emit('search-result', result);
        },

        search ()
        {
            let _matched = []
            if (this.input_searchValue != '')
            {
                this.list_data.forEach( _data => {
                    
                    if ( _data.searchValue && _data.searchValue.indexOf( this.input_searchValue ) !== -1 )
                    {
                        _matched.push( _data )
                    }
                    else if ( Array.isArray(this.search_key) )
                    {
                        let _found = false
                        this.search_key.forEach( _key => {
                            if ( _data[ _key ] && _data[ _key ].toString().indexOf( this.input_searchValue ) !== -1 )
                            {
                                _found = true
                            }
                        })
                        if (_found) _matched.push( _data )
                    }
                })
            }
            return _matched
        },

        clearSearchValue ()
        {
            this.input_searchValue = '';
        }
    }
}
</script>

<style lang="scss" scoped>

.searchbox-block
{
    // display: inline-block;
    text-align: right;
}

.searchbox-area
{
    display: inline-block;
    margin: 5px;
}

.searchbox-icon
{
    display: inline-block;
    vertical-align: middle;
    font-size: 1.5rem;
    margin: 2px 0px;
    color: #8bbf4f;
}

.searchbox-bar
{
    display: inline-block;
    vertical-align: middle;
}

.searchbox-input
{
    border-radius: 15px;
    border-color: #d0e9b3;
    padding: 0px 13px;
    font-size: 0.95rem;
    width: 150px;
}

.searcjbox-close
{
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;

    font-size: 0.95rem;
    color: #629369;
    border-radius: 15px;
    background-color: #dae9ca;
    width: 23px;
    height: 15px;
    text-align: center;
    padding-bottom: 23px;
    margin-left: -15px;
    margin-right: 5px;

    &:hover, &:active
    {
        color: #fff;
        background-color: #98ce98;
    }
}

.searchbox-info
{
    font-size: 0.9rem;
    // margin-top: -8px;
    margin-right: 10px;
    color: #669b2a;
}

</style>
